import styled from 'styled-components';
import { LabelRegular } from '../typography/typography';

export const IconWrapper = styled.div`
	transition: 0.1s ease-in;

	&:first-of-type {
		margin-right: 12px;
	}
	&:last-of-type {
		margin-left: 12px;
	}

	svg {
		transition: 0.1s ease-in;
	}
`;

export const Title = styled(LabelRegular)<{ className?: string }>`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	transition: 0.1s ease-in;
`;

export const LabelSecondary = styled(LabelRegular)`
	color: rgba(var(--font-supportive), 1);
`;

export const TitleWrapper = styled.div`
	flex: 1;
	min-width: 0;
`;
